import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-5 sm:gap-6" }

import { watch, ref } from "vue";
import DayParamsComponent from "@/views/Calculators/PersonalDates/components/dayReport/DayParamsComponent.vue";
import DayReportControlsComponent from "@/views/Calculators/PersonalDates/components/dayReport/DayReportControlsComponent.vue";
import {
  FavorableDateSelectionRequest,
  FavorableDayReport,
  MonthDayReport,
} from "@/types/calculators";
import { fetchDayReport } from "@/api/favorableDates";
import LoaderIcon from "@/components/icons/LoaderIcon.vue";
import DayDoingsComponent from "@/views/Calculators/PersonalDates/components/dayReport/DayDoingsComponent.vue";
import DailyHealthTaboosComponent from "@/views/Calculators/PersonalDates/components/dayReport/DailyHealthTaboosComponent.vue";
import HourlyReportTableComponent from "@/views/Calculators/PersonalDates/components/dayReport/HourlyReportTableComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DayDetailReportComponent',
  props: {
    lastRequest: {},
    selectedCard: {}
  },
  emits: ["backToCalendar", "nextDay", "prevDay"],
  setup(__props: any) {

const props = __props;


const dayDetailsInfo = ref<FavorableDayReport | null>(null);
const waitApiCall = ref<boolean>(false);

watch(
  () => props.selectedCard,
  async (newCard) => {
    if (
      dayDetailsInfo.value === null ||
      dayDetailsInfo.value.meta.target_date !== newCard.date
    ) {
      waitApiCall.value = true;
      dayDetailsInfo.value = await fetchDayReport(
        props.lastRequest,
        newCard.date
      );
      waitApiCall.value = false;
    }
  },
  { deep: true, immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(DayReportControlsComponent, {
      onBackToCalendar: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('backToCalendar'))),
      onNextDay: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('nextDay'))),
      onPrevDay: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('prevDay')))
    }),
    (waitApiCall.value || !dayDetailsInfo.value)
      ? (_openBlock(), _createBlock(LoaderIcon, {
          key: 0,
          spinnerColor: "brown",
          class: "mx-auto"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(DayParamsComponent, {
            selectedCard: __props.selectedCard,
            dayDetailsInfo: dayDetailsInfo.value,
            latitude: __props.lastRequest.latitude,
            longitude: __props.lastRequest.longitude,
            timezone: __props.lastRequest.timezone
          }, null, 8, ["selectedCard", "dayDetailsInfo", "latitude", "longitude", "timezone"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(DayDoingsComponent, {
              dayDetailsInfo: dayDetailsInfo.value,
              activityScope: __props.lastRequest.activity_scope
            }, null, 8, ["dayDetailsInfo", "activityScope"]),
            _createVNode(DailyHealthTaboosComponent, {
              bodyAndStem: dayDetailsInfo.value.day_report.general.shen_sha.body_and_stem
            }, null, 8, ["bodyAndStem"])
          ]),
          _createVNode(HourlyReportTableComponent, {
            timeOffset: 
        dayDetailsInfo.value.day_report.general.astronomical_watches
          .solar_time_offset_min
      ,
            hours: dayDetailsInfo.value.hours_report
          }, null, 8, ["timeOffset", "hours"])
        ], 64))
  ], 64))
}
}

})